import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";
import LienTableItem from "./LienTableItem";

import classes from './LienTableItem.module.css'


export default function LientTable({items}) {    
    let userPermissionDisabled = useUserTabEditPermissionDisabled('lien_edit')

    return <div className={classes.table_container}>
        

        <table className='table-border-radius-8'>
            <thead>
                <tr>
                    <th>Practice</th>
                    <th>Chart Number</th>
                    <th>Location</th>
                    <th>Lien Status</th>
                    <th>Current Balance</th>
                    <th>Lien Amount</th>
                    <th className="table-cell-fit">Notice date</th>
                    <th className="table-cell-fit">Lien Date</th>
                    <th className="table-cell-fit">Amended Lien Date</th>
                    <th className="table-cell-fit">Satisfaction Date</th>
                    <th className="table-cell-fit">Satisfaction Letter Date</th>
                </tr>
            </thead>
            <tbody>
                {items.map(item => (
                    <LienTableItem key={item.id} drawerData={item} permission={userPermissionDisabled}/>
                ))}
            </tbody>
        </table>
    </div>
}